<template>
  <button
    :id="id"
    :class="{ relative: $storyblok.isEditing.value }"
    type="button"
    aria-label="Set location"
    @click="$overlay.open('locationModal', setFocus)"
  >
    <span
      class="flex items-center justify-between cursor-pointer lg:p-0"
      :class="classes"
      data-testid="locationDisplay"
    >
      <span class="flex items-center text-sm">
        <LocationIcon class="w-4 h-4 mr-1 fill-current" aria-hidden="true" tabindex="-1" />
        <span>{{ locationText }}</span>
      </span>
    </span>

    <!-- Shade for storyblok editor to prevent clicks -->
    <span v-if="$storyblok.isEditing.value" class="absolute inset-0 z-[50]"></span>
  </button>
</template>

<script setup lang="ts">
import LocationIcon from '@/assets/location.svg?component'

const { isIntegrationEnabled } = useUtils()
const { formattedLocation } = useLocation()
const id = useId()

interface GeoTextWidget extends Widget {
  textColor: FontColor
}

const { data } = defineProps<{
  data: GeoTextWidget
}>()

const classes = computed(() => {
  return generateFontColorClass(data?.textColor)
})

const locationText = computed(() => {
  return isIntegrationEnabled('googlePlaces') ? formattedLocation : 'Geolocation Disabled'
})

function setFocus() {
  document.getElementById(id)?.focus()
}
</script>
